import styled from "styled-components";

export const Heading = styled.div<{ smallVerticalMargin?: boolean }>`
	margin-top: ${p => p.smallVerticalMargin ? "0px" : "20px"};
	margin-bottom: ${p => p.smallVerticalMargin ? "20px" : "30px"};
	padding-bottom: 5px;
	text-align: center;
	border-bottom: solid 1px #eee;
`;